export default __webpack_public_path__ + "static/media/stader.806ff5eb.png";